'use strict';

var _ = require('lodash');
var GridSendFlightButtonController = function GridSendFlightButtonController($scope, $rootScope, $q, scenarioService, reoptimizationSaveService, overridesSaveService, reoptPreviewDataUtilsService, saveButtonUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  var showByDefaultOnGrids = ['inventory-management', 'overbooking-management'];
  $scope.flightSendPermissions = {
    'reopt': 'write',
    'flight-optimization': 'write'
  };
  $scope.isSendButtonShow = false;
  $scope.onRowSelection = function (event, selectedRows) {
    var isScenarioSelected = scenarioService.isScenarioSelected();
    $scope.selectedRows = selectedRows;
    $scope.isSendButtonShow = _.size($scope.selectedRows) > 0 && !isScenarioSelected || showByDefaultOnGrids.indexOf(gridPanel.gridId) > -1;
  };
  $scope.sendFlights = function () {
    var promise = [];
    var sendRequested = 'Y';
    if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
      var reoptRow = isFlightManagementGrid(gridPanel.gridId) ? gridPanel.reoptPreviewData.ndReopt : $scope.selectedRows[0];
      promise.push(reoptimizationSaveService.ndReoptPublishDocuments(reoptRow, sendRequested));
    }
    if (reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)) {
      promise.push(reoptimizationSaveService.mdReoptPublishDocuments(gridPanel.reoptPreviewData.mdReopt));
    }
    if (promise.length) {
      $q.all(promise).then(function () {
        $q.all(isFlightManagementGrid(gridPanel.gridId) ? saveOverridesFlightManagement() : saveOverridesFlightAnalysis()).then(function () {
          $rootScope.$broadcast('sendGrid', gridPanel.gridId, prepareToSend());
        });
      });
    } else {
      $rootScope.$broadcast('sendGrid', gridPanel.gridId, prepareToSend());
    }
  };
  function saveOverridesFlightManagement() {
    var gridToSaveOverrides = _.concat(showByDefaultOnGrids, ['market-product-group-analysis', 'service-demand-analysis']);
    return _.map(gridToSaveOverrides, function (gridId) {
      var jqxSettings = gridPanel.reoptPreviewData.gridDetails[gridId];
      if (jqxSettings) {
        return overridesSaveService.saveOverrides(saveButtonUtilsService.getEditedRows(jqxSettings), gridId, scenarioService.PUBLISHED);
      }
    });
  }
  function saveOverridesFlightAnalysis() {
    var saveOverridesPromises;
    var visibleFlightGrid = gridPanel.reoptPreviewData.visibleFlightGrid;
    var visibleMarketGrid = gridPanel.reoptPreviewData.visibleMarketGrid;
    var jqxFlightGrid = gridPanel.reoptPreviewData.gridDetails[visibleFlightGrid];
    var jqxMarketGrid = gridPanel.reoptPreviewData.gridDetails[visibleMarketGrid];
    saveOverridesPromises = [overridesSaveService.saveOverrides(saveButtonUtilsService.getEditedRows(jqxFlightGrid), visibleFlightGrid, scenarioService.PUBLISHED)];
    if (reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)) {
      saveOverridesPromises.push(overridesSaveService.saveOverrides(saveButtonUtilsService.getEditedRows(jqxMarketGrid), visibleMarketGrid, scenarioService.PUBLISHED));
    }
    return saveOverridesPromises;
  }
  function isFlightManagementGrid(gridId) {
    return showByDefaultOnGrids.indexOf(gridId) > -1;
  }
  function prepareToSend() {
    if (isFlightManagementGrid(gridPanel.gridId)) {
      return _.size($scope.selectedRows) > 0 ? $scope.selectedRows : _.get(gridPanel, 'jqxGridSettings.source.loadedData', []);
    }
    return $scope.selectedRows;
  }
};
GridSendFlightButtonController.$inject = ['$scope', '$rootScope', '$q', 'ScenarioService', 'ReoptimizationSaveService', 'OverridesSaveService', 'ReoptPreviewDataUtilsService', 'SaveButtonUtilsService'];
module.exports = GridSendFlightButtonController;